import { Record, List } from "immutable";

const DataSourceRecord = Record({
  netImportList: List(),
  generatedList: List(),
  consumedList: List(),
  storageList: List()
});

export default DataSourceRecord;
